import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { GrantLicenseModes } from './SyncActiveDirectoryGroupRequest';

export interface IUpdateGroupParams {
  groupId: string;
  groupSettings: IGroupSettingsParams;
}

export interface IGroupSettingsParams {
  name: string;
  minimumSiteRole: string;
  grantLicenseMode: GrantLicenseModes;
  externalUserRnabled: boolean;
}

export class UpdateGroupRequest extends Request<IUpdateGroupParams, IResult> {
  constructor(params: IUpdateGroupParams) {
    super('updateGroup', params);
  }
}
